import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    IAttachmentResponse,
    TTaskStatus,
    UpdatedTaskForEditModal,
} from 'entities/task/model/types/tasks';
import { IEditModalSchema } from '../../../../entities/modal/model/types/editModalSchema';

const initialState: IEditModalSchema = {
    taskUid: '',
    isCompleted: false,
    title: '',
    description: '',
    dateStart: '',
    dateEnd: '',
    tags: [],
    color: '#9DA1AC',
    status: 'is_waiting',
    observerIds: [],
    estimateId: '',
    executorId: '',
    projectId: '',
    entityUid: '',
    attachments: [],

    isLoading: false,
    error: null as string | null,
};

export const editModalSlice = createSlice({
    name: 'editModal',
    initialState,
    reducers: {
        changeEditModalError: (state, { payload }: PayloadAction<string>) => {
            state.error = payload;
        },
        changeEditModalIsLoading: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoading = payload;
        },
        changeEditModalIsCompleted: (state, { payload }: PayloadAction<boolean>) => {
            state.isCompleted = payload;
        },
        changeEditModalTitle: (state, { payload }: PayloadAction<string>) => {
            state.title = payload;
        },
        changeEditModalDescription: (state, { payload }: PayloadAction<string>) => {
            state.description = payload;
        },
        changeEditModalStartDate: (state, { payload }: PayloadAction<string>) => {
            state.dateStart = payload;
        },
        changeEditModalEndDate: (state, { payload }: PayloadAction<string>) => {
            state.dateEnd = payload;
        },
        changeEditModalTags: (state, { payload }: PayloadAction<string[]>) => {
            state.tags = payload;
        },
        changeEditModalColor: (state, { payload }: PayloadAction<string>) => {
            state.color = payload;
        },
        changeEditModalObserverIds: (state, { payload }: PayloadAction<number[]>) => {
            state.observerIds = payload;
        },
        removeEditModalObserverIds: (state, { payload }: PayloadAction<number>) => {
            state.observerIds = state.observerIds.filter((id) => id !== payload);
        },
        changeEditModalEstimateId: (state, { payload }: PayloadAction<number | null>) => {
            state.estimateId = payload;
        },
        changeEditModalExecutorId: (state, { payload }: PayloadAction<number | null>) => {
            state.executorId = payload;
        },
        changeEditModalProjectId: (state, { payload }: PayloadAction<number | null>) => {
            state.projectId = payload;
        },
        toggleEditModalStatus: (state, { payload }: PayloadAction<TTaskStatus>) => {
            state.status = payload;
        },
        changeEditModalAttachments: (state, { payload }: PayloadAction<IAttachmentResponse[]>) => {
            state.attachments = payload;
        },
        setEditModalData: (state, { payload }: PayloadAction<UpdatedTaskForEditModal>) => {
            state.status = payload.context.status;
            state.title = payload.title;
            state.description = payload.context.description;
            state.dateEnd = payload.date_end;
            state.dateStart = payload.date_start;
            state.tags = payload.context.tags;
            state.color = payload.context.color;
            state.isCompleted = payload.completed;
            state.observerIds = payload.involved.observer_ids;
            state.estimateId = payload.estimate_id;
            state.executorId = payload.involved.executor_id;
            state.projectId = payload.project_id;
            state.taskUid = payload.uid;
            state.entityUid = payload.context.entity_uid;
        },
        resetEditModalData: (state) => {
            state.isLoading = false;
            state.error = null;
            state.isCompleted = false;
            state.title = '';
            state.description = '';
            state.dateStart = '';
            state.dateEnd = '';
            state.tags = [];
            state.color = '#9DA1AC';
            state.status = 'is_waiting';
            state.observerIds = [];
            state.estimateId = '';
            state.executorId = '';
            state.projectId = '';
            state.attachments = [];
        },
    },
    // extraReducers: (builder) => {
    //     builder
    //         .addCase(createCustomTask.pending, (state) => {
    //             state.isLoading = true;
    //             state.error = null;
    //         })
    //         .addCase(createCustomTask.fulfilled, (state, action) => {
    //             state.isLoading = false;
    //             state.error = null;
    //         })
    //         .addCase(createCustomTask.rejected, (state, { payload }) => {
    //             state.isLoading = false;
    //             state.error = '';
    //         });
    // },
});

export const {
    changeEditModalAttachments,
    changeEditModalError,
    changeEditModalIsLoading,
    changeEditModalIsCompleted,
    changeEditModalTitle,
    changeEditModalDescription,
    changeEditModalStartDate,
    changeEditModalEndDate,
    changeEditModalTags,
    changeEditModalColor,
    changeEditModalObserverIds,
    removeEditModalObserverIds,
    changeEditModalEstimateId,
    changeEditModalExecutorId,
    changeEditModalProjectId,
    toggleEditModalStatus,
    setEditModalData,
    resetEditModalData,
} = editModalSlice.actions;
export const { reducer: editModalReducer } = editModalSlice;
